"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CantRemoveCarAlertModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var CantRemoveCarAlertModal = /** @class */ (function (_super) {
    __extends(CantRemoveCarAlertModal, _super);
    function CantRemoveCarAlertModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CantRemoveCarAlertModal.prototype.render = function () {
        var _a = this.props, reason = _a.reason, isOpen = _a.isOpen, toggle = _a.toggle;
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: isOpen, toggle: toggle, centered: true, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: toggle, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("img", { className: "d-block mr-3 mb-1", src: "/img/Flow-attention.svg", alt: "warning" }), (0, jsx_runtime_1.jsx)("h4", { className: "text-blue-1 font-weight-medium", children: "Can't remove car" })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "py-0", children: reason }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { className: "d-block", children: (0, jsx_runtime_1.jsx)("button", { id: "cant-remove-car-alert-close", type: "button", className: "btn btn-primary btn-next w-100", onClick: toggle, children: "OK" }) })] }));
    };
    return CantRemoveCarAlertModal;
}(React.Component));
exports.CantRemoveCarAlertModal = CantRemoveCarAlertModal;
//# sourceMappingURL=CantRemoveCarAlertModal.js.map